export enum BidIntentButtonColours {
    VIEW_ONLY_INTNET_COLOUR = 'unauthorized',
    IM_OUT_INTENT_COLOUR = 'active',
    MAY_BID_INTENT_COLOUR = ''
}
